import { render, staticRenderFns } from "./VegetableView.vue?vue&type=template&id=91886d9c&scoped=true"
import script from "./VegetableView.vue?vue&type=script&lang=js"
export * from "./VegetableView.vue?vue&type=script&lang=js"
import style0 from "./VegetableView.vue?vue&type=style&index=0&id=91886d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91886d9c",
  null
  
)

export default component.exports